import { useLocation } from 'react-router-dom';
import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { LetterActions } from 'assets/js/pages/engage/letters/LetterActions';
import { LetterConfirmationDetails } from 'assets/js/pages/engage/letters/LetterConfirmationDetails';
import { LetterPreview } from 'assets/js/pages/engage/letters/LetterPreview';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import * as Breadcrumbs from 'components/breadcrumbs';
import { MessageStatus } from 'constants/messages';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const REFETCH_INTERVAL = 10000;

const LetterDetailsManual = () => {
    const location = useLocation();
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter({
        refetchInterval: query => (!query.state.data?.downloads.zip ? REFETCH_INTERVAL : false),
    });

    return (
        <div className={'mx-auto flex w-full max-w-screen-md flex-col gap-4'}>
            {letter.status === 'failed' && (
                <AlertNotification.Root type={'error'}>
                    <AlertNotification.Icon />
                    <AlertNotification.Content>
                        <AlertNotification.Title>
                            Letters failed to generate
                        </AlertNotification.Title>
                        <AlertNotification.Description>
                            An issue occurred while generating your letters. Please contact support
                            by clicking the chat icon in the top right corner.
                        </AlertNotification.Description>
                    </AlertNotification.Content>
                    <AlertNotification.Close />
                </AlertNotification.Root>
            )}
            {[MessageStatus.SENDING, MessageStatus.SENT].some(s => s === letter.status) && (
                <AlertNotification.Root type={'info'}>
                    <AlertNotification.Icon />
                    <AlertNotification.Content>
                        <AlertNotification.Title>
                            Letters have finished generating
                        </AlertNotification.Title>
                        <AlertNotification.Description>
                            The letters created for {letter.internal_name} are ready for download.
                        </AlertNotification.Description>
                    </AlertNotification.Content>
                    <AlertNotification.Close />
                </AlertNotification.Root>
            )}
            {[MessageStatus.QUEUED, MessageStatus.PREPARING].some(s => s === letter.status) && (
                <AlertNotification.Root type={'success'}>
                    <AlertNotification.Icon />
                    <AlertNotification.Content>
                        <AlertNotification.Title>
                            Letters are being generated
                        </AlertNotification.Title>
                        <AlertNotification.Description>
                            We are in the process of creating your letters and will notify you via
                            email upon completion. Feel free to close this page and return at
                            anytime.
                        </AlertNotification.Description>
                    </AlertNotification.Content>
                </AlertNotification.Root>
            )}
            <Breadcrumbs.Root>
                <Breadcrumbs.Crumb to={`/accounts/${accountId}/engage/letters`}>
                    Mailings
                </Breadcrumbs.Crumb>
                <Breadcrumbs.Crumb to={location.pathname}>
                    {letter?.internal_name}
                </Breadcrumbs.Crumb>
            </Breadcrumbs.Root>
            <LetterActions />
            <LetterConfirmationDetails />
            <LetterPreview />
        </div>
    );
};

export { LetterDetailsManual };
